import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import FromTo from '../fromTo/FromTo';
import styles from '../FloorPopup/styles.module.scss';
import Button from '../../../ui/button';
import { CustomFilterBodyProps } from '../customFilter.type';

const PricePopup: React.FC<CustomFilterBodyProps> = observer(({ childs }) => {
  const [data, setData] = useState<any>(
    childs.map((child: any) => ({
      ...child,
      value: child.id,
      id: child.id,
    })),
  );

  const handleInputChange = (value: string, i: number) => {
    const res = data;
    res[i] = {
      ...res[i],
      id: value,
      value,
    };
    setData([...res]);
  };
  return (
    <div className={styles.FloorDropdown} onClick={(e) => e.stopPropagation()}>
      <FromTo
        childs={data}
        handleChange={(e: any, index: any) =>
          handleInputChange(e.target.value, index)
        }
      />
      <div className={styles.btnsContainer}>
        <Button
          color="text"
          type="rounded-10"
          size="sm"
          className={styles.btn}
          onClick={() => data[0].onCancel()}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          type="rounded-10"
          size="sm"
          className={styles.btn}
          onClick={() => {
            data[0].onConfirm(data);
          }}
        >
          Select
        </Button>
      </div>
    </div>
  );
});

export default PricePopup;
